import type { ReactNode } from "react";
import { useAtom } from "jotai";
import { LoginDialog } from "@/components/dialogs/LoginDialog";
import { RegisterDialog } from "@/components/dialogs/RegisterDialog";
import { ForgotPasswordDialog } from "@/components/dialogs/ForgotPasswordDialog";
import {
  forgotPasswordDialog,
  loginDialog,
  registerDialog,
  contactDialog,
  androidReviewDialog,
} from "@/state/dialogs";
import { useUser } from "@/hooks/useUser";
import { Pro } from "@/components/pro/Pro";
import { ContactDialog } from "@/components/dialogs/ContactDialog";
import { EnvironmentIndicator } from "@/components/ui/EnvironmentIndicator";
import { proDialog } from "@/state/dialogs";
import { AndroidReviewDialog } from "@/components/dialogs/AndroidReviewDialog";

export function RootClientLayout({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useUser();

  const [isLoginDialogOpen, setLoginDialogOpen] = useAtom(loginDialog);
  const [isRegisterDialogOpen, setRegisterDialogOpen] = useAtom(registerDialog);
  const [isForgotPasswordDialogOpen, setForgotPasswordDialogOpen] = useAtom(forgotPasswordDialog);
  const [isProDialogOpen, setProDialogOpen] = useAtom(proDialog);
  const [isContactDialogOpen, setContactDialogOpen] = useAtom(contactDialog);
  const [isAndroidReviewDialogOpen, setAndroidReviewDialogOpen] = useAtom(androidReviewDialog);

  return (
    <>
      {!isAuthenticated && (
        <>
          <RegisterDialog open={isRegisterDialogOpen} onOpenChange={setRegisterDialogOpen} />
          <LoginDialog open={isLoginDialogOpen} onOpenChange={setLoginDialogOpen} />

          <ForgotPasswordDialog
            open={isForgotPasswordDialogOpen}
            onOpenChange={setForgotPasswordDialogOpen}
          />
        </>
      )}

      <AndroidReviewDialog
        open={isAndroidReviewDialogOpen}
        onOpenChange={setAndroidReviewDialogOpen}
      />

      <ContactDialog open={isContactDialogOpen} onOpenChange={setContactDialogOpen} />

      <Pro open={isProDialogOpen} onOpenChange={setProDialogOpen} />

      {children}

      <EnvironmentIndicator />
    </>
  );
}
